/*
 * 展开菜单 event bus
 *
 * @Author:    1024创新实验室-主任：卓大
 * @Date:      2022-07-12 23:32:48
 * @Wechat:    zhuda1024
 * @Email:     lab1024@163.com
 * @Copyright  1024创新实验室 ( https://1024lab.net )，Since 2012
 */
import mitt from 'mitt';
export default mitt();
